/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ArticleQueryVariables = {
    id: string;
};
export type ArticleQueryResponse = {
    readonly article: {
        readonly id: string;
        readonly _id: string;
        readonly title: string;
        readonly text: string;
        readonly createdAt: unknown;
    } | null;
};
export type ArticleQuery = {
    readonly response: ArticleQueryResponse;
    readonly variables: ArticleQueryVariables;
};



/*
query ArticleQuery(
  $id: ID!
) {
  article(id: $id) {
    id
    _id
    title
    text
    createdAt
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Article",
    "kind": "LinkedField",
    "name": "article",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArticleQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArticleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d8db0d0208c843c173618af02aa0aba",
    "id": null,
    "metadata": {},
    "name": "ArticleQuery",
    "operationKind": "query",
    "text": "query ArticleQuery(\n  $id: ID!\n) {\n  article(id: $id) {\n    id\n    _id\n    title\n    text\n    createdAt\n  }\n}\n"
  }
};
})();
(node as any).hash = '10e89af791088cabd1b00de79f63bd1f';
export default node;
